<template>
  <div
    :class="{
      'd-flex flex-row flex-wrap': displayRow,
    }"
  >
    <div
      v-for="(kiddos, id) in tagGroups"
      :key="id"
      class="mr-2"
      :class="{ 'd-flex flex-row flex-wrap': level > 0 }"
    >
      <v-chip
        v-if="!allowedTags || allowedTags.includes(id)"
        small
        :label="displayOnly"
        class="mb-1 mr-2 borderedChip"
        :class="{ borderedChip: displayOnly }"
        :color="tagColor(id)"
        @click="tagClicked(id)"
        style="min-width: 120px"
      >
        <!--    :disabled="(disable || parentDisabled) && !displayOnly" -->
        <v-icon left small class="mr-2" v-if="showCheckbox(id)">
          mdi-{{
            activeTags.includes(id) && !parentDisabled
              ? "checkbox-marked-outline"
              : "checkbox-blank-outline"
          }}</v-icon
        >
        <!-- <span v-if="parentId">{{ tags[parentId].name }}</span> - -->
        {{ tags[id].name }}
        <!-- show id just for testing -->
        <!-- ({{ id }}) -->
      </v-chip>
      <!-- {{ kiddos }} -->
      <div
        v-if="
          kiddos &&
          !Array.isArray(kiddos) &&
          (!allowedTags || allowedTags.includes(id))
        "
        class="ml-4"
      >
        <!-- ({{ groupHasGrandkids(kiddos) }}) -->
        <rgp-tag-selector-group
          :parentId="id"
          :parentIds="[...parentIds, id]"
          :tags="tags"
          :tagGroups="kiddos"
          :activeTags="activeTags"
          :allowedTags="allowedTags"
          :disable="parentDisabled"
          :displayRow="!groupHasGrandkids(kiddos)"
          :displayOnly="displayOnly"
          :level="level + 1"
          @tagClicked="$emit('tagClicked', $event)"
        ></rgp-tag-selector-group>
      </div>
    </div>
  </div>
</template>

<script>
// import Name from "../dir/file";

export default {
  name: "RgpTagSelectorGroup",
  props: {
    disable: null,
    parentId: null, // for nested tags
    parentIds: { type: Array, default: () => [] }, // for nested tags
    tagGroups: null,
    tags: null,
    allowedTags: null,
    universalTags: null, // tags that all items include
    displayRow: null,
    displayOnly: null,
    hideDisabled: null,
    activeTags: {
      type: Array,
      default: () => [],
    },
    level: { type: Number, default: 0 },
  },
  data: function () {
    return {};
  },
  methods: {
    tagClicked(id) {
      if (this.showCheckbox(id)) {
        this.$emit("tagClicked", id);
      } else {
        let tagObj = this.tags[id];
        this.$router.push({ path: `/rgps/tag/${tagObj.slug}` });
      }
    },
    groupHasGrandkids(groups) {
      let rtn = 0;
      let groupIds = Object.keys(groups);
      groupIds.forEach((groupId) => {
        let groupKids = groups[groupId];
        rtn += Object.keys(groupKids).length;
      });
      return rtn > 0;
    },
    colorForLabel(id) {
      let adjust = this.parentIds ? this.parentIds.length : 0;
      let pcnt = 85 + adjust * 7;
      pcnt = Math.min(pcnt, 100);
      let num = this.parentIds?.[0] ? this.parentIds[0] : id;
      return `hsl(${num * 4}deg 80% ${pcnt}%)`;
    },

    tagColor(id) {
      //   let c =
      //     this.activeTags.includes(id) && !this.parentDisabled
      //       ? "orange lighten-3"
      //       : "gray";
      //     if (this.displayOnly)
      let c = this.colorForLabel(id);
      return c;
    },
    showCheckbox(id) {
      let isUniversal = this.universalTags && this.universalTags.includes(id);

      //   console.log("showCheckbox: ", id, this.displayOnly, isUniversal);
      return !this.displayOnly && !isUniversal;
    },
  },
  computed: {
    parentDisabled: function () {
      let parentDisabled = false;
      let at = this.activeTags;
      if (!this.parentIds) return false;
      //   console.log("parentIDs", this.parentIds);
      this.parentIds.forEach((id) => {
        if (!at.includes(id)) parentDisabled = true;
      });
      return parentDisabled;
    },
  },
  watch: {},
  mounted() {},
};
</script>

<style scoped>
.borderedChip {
  border: 1px solid #e0e0e0 !important;
}
</style>
